// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".full-page-dropzone[data-v-93e6ca88]{position:fixed;top:0;bottom:0;left:0;right:0;background-color:#727cf5;z-index:9999;display:flex;justify-content:center;align-items:center;flex-direction:column;color:#fff}.full-page-dropzone p[data-v-93e6ca88]{font-size:2em;font-weight:400;pointer-events:none}.full-page-dropzone img[data-v-93e6ca88]{margin-bottom:20px;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
